var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReseller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9991 2H16.9991C17.5491 2 17.9991 1.55 17.9991 1C17.9991 0.45 17.5491 0 16.9991 0H2.9991C2.4491 0 1.9991 0.45 1.9991 1C1.9991 1.55 2.4491 2 2.9991 2ZM18.1591 3.8C18.0691 3.34 17.6591 3 17.1791 3H2.8191C2.3391 3 1.9291 3.34 1.8391 3.8L0.839097 8.8C0.719097 9.42 1.1891 10 1.8191 10H1.9991V15C1.9991 15.55 2.4491 16 2.9991 16H10.9991C11.5491 16 11.9991 15.55 11.9991 15V10H15.9991V15C15.9991 15.55 16.4491 16 16.9991 16C17.5491 16 17.9991 15.55 17.9991 15V10H18.1791C18.8091 10 19.2791 9.42 19.1591 8.8L18.1591 3.8ZM3.9991 14H9.9991V10H3.9991V14Z",
    fill: "#001B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReseller);
export default __webpack_public_path__ + "static/media/reseller.4f25c1be327453d876b2ceb73d819d0d.svg";
export { ForwardRef as ReactComponent };